import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/language-helper';
import {loginUiTexts} from 'data/ui-texts/login-ui-texts';
import Button from 'components/ui/button/button';
import './admin-login.scss';

const AdminLogin = (props) => {
	let {
		isLoading,
		languageId,
		email,
		password,
		feedback,
		handleInput,
		handleLogin
	} = props;

	return (
		<div className="AdminLogin">
			<div className="AdminLogin-content">
				<div className="AdminLogin-title">
					<span>{getText(loginUiTexts.admin, languageId)}</span>
				</div>
				<div className="AdminLogin-body">
					<form className="AdminLogin-form" onSubmit={(e) => {handleLogin(e);}}>
						<input
							name="email"
							type="text"
							placeholder={getText(loginUiTexts.email, languageId)} 
							autoComplete="section-adminLogin email"
							value={email ? email : ''} 
							onChange={(event)=>{handleInput(event);}}
						/>
						<input
							name="password"
							type="password"
							placeholder={getText(loginUiTexts.password, languageId)}
							autoComplete="section-adminLogin password"
							value={password ? password : ''} 
							onChange={(event)=>{handleInput(event);}}
						/>
				
						<div className="AdminLogin-loginBtn">
							<Button 
								isLoading={isLoading}
								classes={['login']}
								text={getText(loginUiTexts.login, languageId)}
								onClick={() => {handleLogin();}}
								type='submit'
							/>
						</div>
					</form>
			
					<div className="AdminLogin-errorMessage">
						<span>{feedback}</span>
					</div> 
				</div>
			</div>
		</div>
	);
};

AdminLogin.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	email: PropTypes.string,
	password: PropTypes.string,
	feedback: PropTypes.string,
	handleLogin: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired,
};

export default AdminLogin;